import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import DynamicSubHeader from '@ifca-root/react-component/src/components/Header/DynamicSubHeader'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import {
  useGetUsersByAccountAndSoftwareQuery,
  UserSelection,
} from 'generated/graphql'
import React from 'react'
import { useHistory, useLocation, useParams } from 'react-router'
import { HistoryDepreciationDetailContent } from './HistoryDepreciationDetailContent'

export const HistoryDepreciationDetail = (props: any) => {
  let history = useHistory()
  const { CompanyID, DepreciationLedgerID }: any = useParams()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  let location = useLocation()
  const itemData = location?.state as any
  console.log('itemData: ', itemData)

  const {
    loading: getUsersByAccountAndSoftwareLoading,
    data: { getUsersByAccountAndSoftware } = {
      getUsersByAccountAndSoftware: [],
    },
  } = useGetUsersByAccountAndSoftwareQuery({
    fetchPolicy: 'network-only',
    variables: {
      superUserBool: UserSelection.All,
    },
  })
  const formatPeriod = (year: number, period: number) => {
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ]
    return `${months[period - 1]}/${year}`
  }

  const periodDisplay = formatPeriod(itemData?.year, itemData?.period)
  const postedStatus = itemData?.posted_to_gl ? 'Posted' : 'Pending'

  return (
    <>
      {getUsersByAccountAndSoftwareLoading && <Loading />}

      <MainHeader
        mainBtn="back"
        onClick={() => {
          history.push(`/fixed-assets/${CompanyID}/depreciation/history`)
        }}
        smTitle="Fixed Assets"
        title={user?.companyName}
        routeSegments={[
          { name: 'Fixed Assets' },
          { name: 'Depreciation' },
          { name: 'History', current: true },
        ]}
        rightRouteSegments={[{ name: postedStatus, current: true }]}
      />

      <DynamicSubHeader
        title={
          <span className="c-orange">
            <span style={{ fontWeight: 'bold' }}>{itemData?.Asset?.name}</span>
          </span>
        }
        // rightText={
        //   <span className="c-orange">{itemData?.Asset?.asset_card_no}</span>
        // }
        infoLine={
          <div
            className="text-overflow"
            style={{ fontSize: '11px', fontWeight: 'bold', width: '270px' }}
          >
            {itemData?.Asset?.Category?.name}
          </div>
        }
        rightInfoLine={
          <span className="desc c-orange">Period: {periodDisplay}</span>
        }
      />

      <ContentWrapper multiDynamicInfo float footer>
        <CardContents>
          <HistoryDepreciationDetailContent
            listEl={itemData}
            userList={getUsersByAccountAndSoftware}
            postedStatus={postedStatus}
          />
        </CardContents>

        <CardContents
          section={{
            header: { title: 'Asset Information' },
          }}
        >
          <div className="content-wrap left">
            <div className="desc" style={{ color: 'grey' }}>
              Asset Name
            </div>
            <div className="mdDesc text-noflow">{itemData?.Asset?.name}</div>
          </div>

          <div className="content-wrap right">
            <div className="desc" style={{ color: 'grey' }}>
              Category
            </div>
            <div className="mdDesc">{itemData?.Asset?.Category?.name}</div>
          </div>

          {/* <div className="content-wrap full">
            <div className="desc" style={{ color: 'grey' }}>
              Asset Name
            </div>
            <div className="mdDesc text-noflow">{itemData?.Asset?.name}</div>
          </div> */}

          <div className="content-wrap left">
            <div className="desc" style={{ color: 'grey' }}>
              Base Original Amount
            </div>
            <div className="mdDesc">
              {itemData?.Asset?.base_original_amount}
            </div>
          </div>

          <div className="content-wrap right">
            <div className="desc" style={{ color: 'grey' }}>
              Net Amount
            </div>
            <div className="mdDesc">{itemData?.Asset?.original_net_amount}</div>
          </div>

          <div className="content-wrap left">
            <div className="desc" style={{ color: 'grey' }}>
              Depreciation Method
            </div>
            <div className="mdDesc">{itemData?.DepreciationMethod?.name}</div>
          </div>

          <div className="content-wrap right">
            <div className="desc" style={{ color: 'grey' }}>
              Useful Life
            </div>
            <div className="mdDesc">
              {itemData?.Asset?.opening_depreciation_useful_life || 0}
            </div>
          </div>
        </CardContents>
      </ContentWrapper>
    </>
  )
}
